// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"OhKslHXYzM-uS2AXcxVxL","label":"_3dqhvbp6mxCXGanQdPyxag","boxes":"_1Uzo26_oF54lwZ2vHuMjA_","box":"jiIXEZrmety7BruIVAROU","loadingBox":"_2R3chhw65hVGSI_00xkJig","reportBox":"_3n3L8mL2VI-WHPpI0t6IJo"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/container/RequestReportsListPage/index.css
// module id = 410
// module chunks = 0